import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { actions, service } from "./model";
import Dashboard from "./pages/Dashboard";
import EvaluoFormPage from "./pages/EvaluoFormPage";
import TokenRedirect from "./pages/TokenRedirect";
import { CircularProgress, Modal } from "@mui/material";
import ModalError from "./components/Generics/ModalError";

function ProtectedRoute({ children }) {
  const user = useSelector((state) => state.user?.redux_object || null);
  if (user && user.accessToken) return children;
  window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
  return null;
}

function App() {
  const dispatch = useDispatch();
  const reduxObject = useSelector((state) => state.user?.redux_object);

  const [appLoading, setAppLoading] = useState(true);
  const [collaborators, setCollaborators] = useState([]);
  const [evaluations, setEvaluations] = useState([]);
  const [apiErrorModal, setApiErrorModal] = useState(false);

  const user = reduxObject?.user || null;

  const loadAppData = async () => {
    if (!reduxObject?.accessToken) {
      setAppLoading(false);
      return;
    }

    const token = reduxObject.accessToken;

    try {
      const updatedUser = await service.getUser(token);
      if (updatedUser?.role === "partner") {
        const collabs = await service.getCollaborators(token, updatedUser.id);
        setCollaborators(collabs);
      }
      const evals = await service.getAllEvaluations(token);
      setEvaluations(evals);
    } catch (err) {
      console.error(err);
      setApiErrorModal(true);
    }

    setAppLoading(false);
  };

  useEffect(() => {
    loadAppData();
  }, [reduxObject]);

  if (appLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000,
        }}
      >
        <CircularProgress sx={{ color: "#1b2838" }} />
      </div>
    );
  }

  return (
    <>
      <Modal open={apiErrorModal} onClose={() => setApiErrorModal(false)}>
        <div>
          <ModalError
            title="Ops, qualcosa è andato storto"
            descriptionOne="Si è verificato un errore tecnico momentaneo."
            descriptionTwo="Ti invitiamo a riprovare tra qualche minuto. Grazie."
            copyButton="Chiudi"
            confirm={() => setApiErrorModal(false)}
            onClose={() => setApiErrorModal(false)}
            generalError={true}
          />
        </div>
      </Modal>

      <Routes>
        <Route path="/token-login" element={<TokenRedirect />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard
                loadAppData={loadAppData}
                user={user}
                collaborators={collaborators}
                evaluations={evaluations}
                apiErrorModal={apiErrorModal}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/evaluation/:id"
          element={
            <ProtectedRoute>
              <EvaluoFormPage loadAppData={loadAppData} user={user} />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<h1>404: Pagina non trovata</h1>} />
      </Routes>
    </>
  );
}

export default App;
